import {styled} from "@mui/material";
import Base from "../../../components/base";
import {scale} from "../../../utils";
import BaseHeader from "../../../components/base/header";
import BaseTitle from "../../../components/base/title";
import NewDonationForm from "../../../components/form/new-donation";
import LABEL from "../../../resources/label";

const Wrapper = styled('div')({

});

const CreaRaccolta = () => {
  return (
    <Wrapper>
      <Base style={{ width: scale(900), height: scale(750) }}>
        <BaseHeader/>
        <BaseTitle title={LABEL.NEW_DONATION}/>
        <NewDonationForm/>
      </Base>
    </Wrapper>
  );
}

export default CreaRaccolta;
